// extracted by mini-css-extract-plugin
export default {"list":"LinkPosItemList_list__2aNZ0"};